module.exports = __webpack_public_path__ + "assets/ab4f507e9cfa19333e6e7830fefeb4ac.png";